import '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import { createContext } from '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';

var _createContext = /*#__PURE__*/createContext({
  strict: false,
  name: 'PopoverContext',
  errorMessage: 'usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`'
}),
    PopoverProvider = _createContext[0],
    usePopoverContext = _createContext[1];

export { PopoverProvider, usePopoverContext };
//# sourceMappingURL=context.esm.js.map
